import { render, staticRenderFns } from "./Anticipations.vue?vue&type=template&id=9b3876bc&scoped=true"
import script from "./Anticipations.vue?vue&type=script&lang=js"
export * from "./Anticipations.vue?vue&type=script&lang=js"
import style0 from "./Anticipations.vue?vue&type=style&index=0&id=9b3876bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3876bc",
  null
  
)

export default component.exports